export default {"src":"/_next/static/media/WhoWeAre_039A.31cc37a3.JPG","height":714,"width":1920};